import typeform from '~shared/helpers/typeform';
import { useAccount } from '~teacher/hook/account';

export const useTypeFormLink = ({
  medium = null,
  seats = '1',
  years = '1',
}: {
  medium?: 'socrative-pro' | 'socrative-complete-no-price' | 'socrative-complete-price' | null;
  seats?: string;
  years?: string;
} = { medium: null, seats: '1', years: '1' }) => {
  return useAccount({
    select: (accountData: any) =>
      typeform({
        medium,
        seats,
        years,
        ...accountData,
      }),
  });
};
